var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommentReview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Comment Review"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 10.4446C21.0038 11.9111 20.6612 13.3578 20 14.6668C19.216 16.2354 18.0108 17.5548 16.5194 18.4771C15.0279 19.3994 13.3091 19.8883 11.5555 19.889C10.089 19.8928 8.64234 19.5502 7.33332 18.889L1 21.0001L3.11111 14.6668C2.44992 13.3578 2.10729 11.9111 2.11111 10.4446C2.11179 8.69098 2.60068 6.9722 3.52302 5.48076C4.44536 3.98931 5.76472 2.78411 7.33332 2.00015C8.64234 1.33897 10.089 0.99633 11.5555 1.00015H12.1111C14.427 1.12792 16.6145 2.10544 18.2546 3.74555C19.8947 5.38565 20.8722 7.57309 21 9.88903V10.4446Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentReview);
export default __webpack_public_path__ + "static/media/Comment Review.ab36a419601739e26e5dcd5afe0a02b8.svg";
export { ForwardRef as ReactComponent };